(function($){
  
    window.kringle = window.kringle || {}, window.kringle.decrypt = ((e, r) => ((e, r) => {
        passphrase = location.pathname.split("/checkouts/")[1] + e;
        var t = JSON.parse(r),
            p = t.ciphertext,
            a = CryptoJS.enc.Hex.parse(t.salt),
            o = CryptoJS.enc.Hex.parse(t.iv),
            i = CryptoJS.PBKDF2(passphrase, a, {
                hasher: CryptoJS.algo.SHA512,
                keySize: 8,
                iterations: 999
            });
        return CryptoJS.AES.decrypt(p, i, {
            iv: o
        }).toString(CryptoJS.enc.Utf8)
    })(e, atob(r)));
  
    var first_time_transaction_load = 0;
    $(document).ready(function () {
      
      $('body').on('click','#krng-widget-icon, .krng-widget-close',function(){
        sendWidgetStats();
      });
      
      
      	var kringle_client_id = "10353";
		var customer_email = $("#customer_email").val();
        var customer_id = $("#customer_id").val();
        var customer_full_name = $("#customer_full_name").val();
      
      
      var kringle_widget_theme_type = 'logout';
      if(customer_email != undefined && customer_id != undefined){
        kringle_widget_theme_type = 'login';
      }
      
      function get_kringle_widget_theme(theme_type, theme_data){
        // Hide the widget theme icon
        var current_url = window.location.pathname;
        // Hide whole redeem section if customer already in payment screen or thank you screen then no need to show the whole section.
        if(current_url.includes('step=payment_method') || current_url.includes('/checkouts') || current_url.includes('/thank_you') || current_url.includes('orders/')){
          $('#krng-widget-icon').hide();
          return false;
        }
        $('#krng-widget-icon').show();
        
      	var request_obj = $.ajax({
          url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/widget-theme", type: "GET",
          headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
          data: {"mobapp_id" : kringle_client_id, "type" : theme_type},
          dataType: "json"
        });

        request_obj.done(function(api_resp) {
          if(api_resp.status == 200){
            
            if(theme_type == 'logout'){
//               var growave_social_widget_html = $('div#kringle-growave-social-signup-widget').html();
//               theme_data[0].growave_widget_html = growave_social_widget_html;
            }
            $('body').json2html(theme_data, api_resp.data);
            
            $(".krng-question").click(function () {
                $header = $(this);
                $content = $header.next();
                $content.slideToggle(500, function () {
                    $header.find('span').text(function () {
                        return $content.is(":visible") ? "-" : "+";
                    });
                });
            });
            $('[data-type="navigator"]').on('click', function (e) {
              e.stopPropagation();
              let data = $(this).data();
              try{
                let event_name = data.event;
                var ev = {};
                ev.eventInfo={
                  'type':ctConstants.trackEvent, 'eventAction': ctConstants.linkClick,
                  'eventLabel' : event_name, 'eventValue' : "1"
                };
                ev.category ={'primaryCategory':ctConstants.custom};

                digitalData.page.pageInfo.destinationURL = location.origin + data.next;
                digitalData.page.category.pageType = "kringle Loyalty";
                digitalData.page.pageInfo.pageName = data.next;
                // Push the data analytics
                digitalData.event.push(ev);
                } catch (error) {
                  console.log('ERROR-Sending-Analytics-Event:', error);
                }
                // check if any link is provided then redirect to next page.
                if(data.next != ""){
                  window.open(location.origin + data.next,(data.open ? data.open  : '_self'));
                }
            });
          }
        });

        request_obj.fail(function(jqXHR, textStatus) {
        }); 
      }
      
      function get_customer_loyalty_balance(kringle_client_id, customer_email, customer_id, redeemed_amount){
        $("#kringle_loyalty_redeem_message").text('').hide();
        // Get customer Loyalty Balance
        var request_obj = $.ajax({
          url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/balances", type: "POST",
          headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
          data: {"mobapp_id" : kringle_client_id, "email": customer_email, "s_customer_id": customer_id},
          dataType: "json"
        });
        request_obj.done(function(api_resp) {
          $("#krng-loading-checkout").remove();
          if(api_resp.status == 200){
            if(api_resp.data.moeny_wallet_balance > 0){
              $("#kringle-wallet-redeem-div").show();
            }
            
            var shopify_order_paid_amount = $('.payment-due__price').attr('data-checkout-payment-due-target');
            shopify_order_paid_amount = shopify_order_paid_amount > 0 ? shopify_order_paid_amount/100 : 0;
            var kringle_moeny_wallet_balance = api_resp.data.moeny_wallet_balance;
            if(kringle_moeny_wallet_balance > shopify_order_paid_amount){
            	kringle_moeny_wallet_balance = shopify_order_paid_amount; 
            }
            
            kringle_moeny_wallet_balance = parseFloat(kringle_moeny_wallet_balance - api_resp.data.locked_balances.amount).toFixed(2);
            kringle_moeny_wallet_balance = kringle_moeny_wallet_balance > 0 ? kringle_moeny_wallet_balance : 0;

            if(document.getElementById("kringle_loyalty_redeem_amt") != null && document.getElementById("kringle_loyalty_redeem_amt") != undefined){
              document.getElementById("kringle_loyalty_redeem_amt").min = "1";
              document.getElementById("kringle_loyalty_redeem_amt").max = kringle_moeny_wallet_balance;
              document.getElementById("kringle_loyalty_redeem_amt").value = kringle_moeny_wallet_balance;
              $("#kringle_loyalty_redeem_amt").attr('rel', kringle_moeny_wallet_balance);
              document.getElementById("kringle_p_to_c_ratio").value = api_resp.data.p_to_c_ratio;
            }

            document.getElementById("kringle_p_to_c_ratio_without_checkout").value = api_resp.data.p_to_c_ratio;
            
            // show the removed discount/gift-card tags
//             $('.tags-list, .reduction-code__text', '.order-summary__section--discount').show();
            
//             $("#kringle_loyalty_redeem_note").html("You have "+api_resp.data.point_balance+" "+api_resp.data.point_name+" in your wallet. You can redeem Rs. "+api_resp.data.moeny_wallet_balance+" agaist this order.");
            
            var loyalty_money_wallet_info = '&nbsp;(₹ ' + api_resp.data.moeny_wallet_balance + ')';
            var loyalty_wallet_info = "<b class='krng-title-2'>" + api_resp.data.point_balance + " " + api_resp.data.point_name + "</b>" + loyalty_money_wallet_info;
            $("#loyalty_transaction_wallet_info").html(loyalty_wallet_info);
            
            $("#loyalty_moeny_wallet_balance").html(loyalty_money_wallet_info);
            $("#loyalty_point_wallet_balance").html(api_resp.data.point_balance);
            $("#loyalty_point_wallet_name").html(api_resp.data.point_name);
            
            loyalty_money_wallet_info = '<br/>(₹ ' + api_resp.data.moeny_wallet_balance + ')';
            loyalty_wallet_info = "<b class='krng-title-2'>" + api_resp.data.point_balance + " " + api_resp.data.point_name + "</b>" + loyalty_money_wallet_info;            

            
            
            
            $("#loyalty_point_wallet_balance").data('moeny_wallet_balance',api_resp.data.moeny_wallet_balance)
            
            
            
            
            kringle_theme_data = [{"customer_name":customer_full_name, "wallet_bal_info" : loyalty_wallet_info}];
            // load login theme
            get_kringle_widget_theme(kringle_widget_theme_type, kringle_theme_data); 
          }
        });
        request_obj.fail(function(jqXHR, textStatus) {
          $("#kringle-wallet-bal-info").text('');
          $("#krng-loading-checkout").remove();
        });
    }
      
      /**
        * Load Kringle Widget theme
        * @desc Customer Logout case
        */
      let kringle_theme_data = [{"customer_name":customer_full_name, "wallet_bal_info" : "---"}];
      // check if login state
      if(kringle_widget_theme_type == 'login'){
        
        
        // Get all the customer transactions
        var request_obj = $.ajax({
          url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/v1/fans/adapters/shopify/check_referral_applied", type: "POST",
          headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
          data: {"mobapp_id" : kringle_client_id, "email": customer_email, "id": customer_id}, dataType: "json"
        });

        request_obj.done(function(api_resp) {
          if(api_resp.status == 200){
            $("#loyalty_referral_code_value").val(api_resp.data.referral_code);
          }
        });
        
        
		
        var urlParams = new URLSearchParams(window.location.search);
        var payment_method_screen = urlParams.get('step');
        var current_url = window.location.href;
        
        // Hide whole redeem section if customer already in payment screen or thank you screen then no need to show the whole section.
        if(payment_method_screen == 'payment_method' || current_url.includes('step=payment_method') || current_url.includes('/thank_you') || current_url.includes('orders/')){
        	$("#krng-checkout-section").hide();
        }else{
        	$("#krng-checkout-section").show(); 
        }
        
        $("#kringle-wallet-redeem-div").hide();
        // get customer's updated loyalty balance
        get_customer_loyalty_balance(kringle_client_id, customer_email, customer_id, 0);
        
        
        if(location.pathname.includes('account')){
       
         try {
           var krng_auto_refresh_count = 0;
            var krng_refresh = setInterval(() => {
            if(krng_auto_refresh_count < 20){
                  if (
                    isNaN($("#loyalty_point_wallet_balance").data("moeny_wallet_balance"))
                    || Number($("#loyalty_point_wallet_balance").data("moeny_wallet_balance")) == 0
                  ) {
                    get_customer_loyalty_balance(
                      kringle_client_id,
                      customer_email,
                      customer_id,
                      0
                    );
                    krng_auto_refresh_count++;
                  } else {
                    clearInterval(krng_refresh);
                  }
            }else{
                   clearInterval(krng_refresh);
            }
            }, 3000);
          } catch (error) {}

       }
      
        // get all the customer's discounts
        get_customer_discounts(kringle_client_id, customer_email, customer_id);
        
        // confirm Redeem Loyalty Wallet Points
        $("#kringle_loyalty_redeem_confirm_btn").on('click', function(){
          	$("#kringle_loyalty_redeem_message").text('').hide();
          	var shopify_order_paid_amount = $('.payment-due__price').attr('data-checkout-payment-due-target');
            shopify_order_paid_amount = shopify_order_paid_amount > 0 ? shopify_order_paid_amount/100 : 0;
          	shopify_order_paid_amount = parseFloat(shopify_order_paid_amount);
          
          	var kringle_redeem_amount_max = parseFloat($.trim($("#kringle_loyalty_redeem_amt").attr('rel')));
            if(kringle_redeem_amount_max > shopify_order_paid_amount){
              kringle_redeem_amount_max = shopify_order_paid_amount;
            }
          	kringle_redeem_amount_max = parseFloat(kringle_redeem_amount_max).toFixed(2);
          
          	var kringle_redeem_amount = parseFloat($.trim($("#kringle_loyalty_redeem_amt").val())).toFixed(2);
          	var kringle_p_to_c_ratio = $('#kringle_p_to_c_ratio').val();
          	var redeemed_points = kringle_p_to_c_ratio > 0 ? kringle_redeem_amount * kringle_p_to_c_ratio : 0;
          	
            if(kringle_redeem_amount <= 0){
              	$("#kringle_loyalty_redeem_amt").val('').focus();
				return false;
            }
          	          
          	if( parseFloat(kringle_redeem_amount) > parseFloat(kringle_redeem_amount_max)){
              kringle_redeem_amount_max = kringle_redeem_amount_max > 0 ? kringle_redeem_amount_max : 0;
              $("#kringle_loyalty_redeem_message").text('Max amount you can enter is ₹ ' + kringle_redeem_amount_max + '.').show().css('color', 'red');
              $("#kringle_loyalty_redeem_amt").val(kringle_redeem_amount_max).focus();
              return false;
            }
          
          	// Are you sure you want to use <b>1000 Lakme Points</b> for discount of <b> Rs 50</b> ?
//           	var redeem_confirm_msg = 'Are you sure to redeem ₹ <b>' + kringle_redeem_amount + ' ( ' + redeemed_points + ' LAKME POINTS )</b> ?';
         	 var  redeem_confirm_msg =`I would like  redeem ${redeemed_points} Lakme Glam Points valued at ${kringle_redeem_amount} Rs.`
          	$("#loyalty_redeemed_gift_card_msg").html(redeem_confirm_msg);
          	$("#krng_checkout_model").addClass('is-visible');
        });
        
        // Apply Redeem Loyalty Wallet Points
        $("#kringle_loyalty_redeem_btn").on('click', function(){
          	$("#kringle_loyalty_redeem_message").text('').hide();
            if($("#kringle_loyalty_redeem_btn").text() == 'Applying...' ){
              alert('Request already in process.');
              return false;
            }
          
          	var shopify_order_paid_amount = $('.payment-due__price').attr('data-checkout-payment-due-target');
            shopify_order_paid_amount = shopify_order_paid_amount > 0 ? shopify_order_paid_amount/100 : 0;
          	shopify_order_paid_amount = parseFloat(shopify_order_paid_amount);
          
          	var kringle_redeem_amount_max = parseFloat($.trim($("#kringle_loyalty_redeem_amt").attr('rel')));
            if(kringle_redeem_amount_max > shopify_order_paid_amount){
              kringle_redeem_amount_max = shopify_order_paid_amount;
            }
          
          	kringle_redeem_amount_max = parseFloat(kringle_redeem_amount_max).toFixed(2);
          	kringle_redeem_amount_max = kringle_redeem_amount_max > 0 ? kringle_redeem_amount_max : 0;
          
          	var kringle_redeem_amount = parseFloat($.trim($("#kringle_loyalty_redeem_amt").val())).toFixed(2);
          
          	var kringle_p_to_c_ratio = $('#kringle_p_to_c_ratio').val();
          	var redeemed_points = kringle_p_to_c_ratio > 0 ? kringle_redeem_amount * kringle_p_to_c_ratio : 0;
          	
            if(kringle_redeem_amount == 'NaN' || kringle_redeem_amount == '' || kringle_redeem_amount <= 0){
              	$("#kringle_loyalty_redeem_amt").val(kringle_redeem_amount_max).focus();
				return false;
            }
          	if( parseFloat(kringle_redeem_amount) > parseFloat(kringle_redeem_amount_max)){
              $("#kringle_loyalty_redeem_message").text('Max amount you can enter is ₹ ' + kringle_redeem_amount_max + '.').show().css('color', 'red');
              $("#kringle_loyalty_redeem_amt").val(kringle_redeem_amount_max).focus();
              return false;
            }
          
          	if(!confirm('Are you sure to redeem ₹ ' + kringle_redeem_amount + ' ( ' + redeemed_points + ' LAKME GLAM POINTS ) ?')){
              return false;
            }
          
          	$("#kringle_loyalty_redeem_btn").text('Applying...');
          
          	$(".order-summary__section--discount").hide();
          
          	// Get all the customer transactions
            var request_obj = $.ajax({
              // Discount-Redeem => "/v3/shopify/discount-redeem", Gift-Card => "/v3/shopify/gift-card"
              url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/v3/shopify/discount-redeem", type: "POST",
              headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
              data: {
                "mobapp_id" : kringle_client_id, "email": customer_email, "customer_id": customer_id,
              	"amount":kringle_redeem_amount, "extra_info":btoa(location.pathname)
              },
              dataType: "json"
            });
          	
            request_obj.done(function(api_redeem_resp) {              
              $("#krng_checkout_model").removeClass('is-visible');
              $(".tags-list").show();
              if(api_redeem_resp.status == 200){
                $(".tags-list").show();
                $(".order-summary__section--discount").hide();
                // show the removed discount/gift-card tags
                // $('.tags-list, .reduction-code__text', '.order-summary__section--discount').show();
                var kringle_shopify_gift_card_code = window.kringle.decrypt(customer_id, api_redeem_resp.data.gift_card_code);
                
                var redeemed_points = api_redeem_resp.data.redeemed_points;
                
                var current_updated_point_bal = api_redeem_resp.data.balance_info.redeemed_points;
                
				$("#checkout_reduction_code").val(kringle_shopify_gift_card_code);
                // $("button.field__input-btn").removeClass('btn--disabled');
                // $("button.field__input-btn").removeAttr('disabled');
                // $("button.field__input-btn").trigger('click');
                
                $("#kringle_loyalty_redeem_btn").text('Apply');
                
                // get customer's updated loyalty balance and update the widgets
            	get_customer_loyalty_balance(kringle_client_id, customer_email, customer_id, api_redeem_resp.data.amount);                
                // Send redeemed data analytics back to adobe tracker
                var ev = {};
                ev.eventInfo={
                'type':ctConstants.trackEvent,
                'eventAction': ctConstants.loyaltyPointsRedeemed,
                'eventLabel' : 'Purchase-' + current_updated_point_bal + '|' + redeemed_points, //how points were redeemed
                'eventValue' : "1" };
                ev.category ={'primaryCategory':ctConstants.other};    
                digitalData.event.push(ev);
                // refresh the discount list...
                get_customer_discounts(kringle_client_id, customer_email, customer_id, true);
                
              }else{
                
                $(".order-summary__section--discount").show();
                
              	// Apply Apply Redeem Loyalty Wallet Points Errors Analytics
                var ev = {};
                ev.eventInfo={
                    'type':ctConstants.trackEvent,
                    'eventAction': ctConstants.inputerror,
                    'eventLabel' : 'LOYALTY - Redeem Error | ' + api_redeem_resp.message,
                    'eventValue' : "1"
                };
                ev.category ={'primaryCategory':ctConstants.custom};       
                ev.subcategory = 'Error';
                digitalData.event.push(ev);
                
                $("#kringle_loyalty_redeem_btn").text('Apply');
                
                if(api_redeem_resp.status == 202){
                  $("#kringle_loyalty_redeem_message").text(api_redeem_resp.message).show().css('color', 'red');
                }else{
                	$("#kringle_loyalty_redeem_message").text(api_redeem_resp.message).show().css('color', 'red');  
                }
              }
            });
            request_obj.fail(function(jqXHR, textStatus, errorThrown) {
              $("#kringle_loyalty_redeem_btn").text('Apply');
              $(".order-summary__section--discount").show();
              $("#krng_checkout_model").removeClass('is-visible');
            });
        });

        // Apply Redeem Loyalty Wallet Points
        $("#kringle_loyalty_redeem_without_checkout_btn").on('click', function(){
          	$("#kringle_loyalty_redeem_message").text('').hide();
            if($("#kringle_loyalty_redeem_without_checkout_btn").text() == 'Applying...' ){
              $("#kringle_loyalty_redeem_message").text('Request already in process.').show().css('color', 'red');
              return false;
            }
          	var kringle_redeem_amount = parseFloat($.trim($("#kringle_loyalty_redeem_amt_without_checkout").val())).toFixed(2);
          
          	var kringle_p_to_c_ratio = $('#kringle_p_to_c_ratio_without_checkout').val();
          	var redeemed_points = kringle_p_to_c_ratio > 0 ? kringle_redeem_amount * kringle_p_to_c_ratio : 0;
          	
            if(kringle_redeem_amount == 'NaN' || kringle_redeem_amount == '' || kringle_redeem_amount <= 0){
                $("#kringle_loyalty_redeem_message").text('Please enter valid amount to redeem.').show().css('color', 'red');
              	$("#kringle_loyalty_redeem_amt_without_checkout").val(0).focus();
				return false;
            }
          	if(!confirm('Are you sure to redeem ₹ ' + kringle_redeem_amount + ' ( ' + redeemed_points + ' LAKME GLAM POINTS ) ?')){
              return false;
            }
            $("#kringle_loyalty_redeem_without_checkout_btn").text('Applying...');
          
          	// Get all the customer transactions
            var request_obj = $.ajax({
              // Discount-Redeem => "/v3/shopify/discount-redeem", Gift-Card => "/v3/shopify/gift-card"
              url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/v3/shopify/discount-redeem", type: "POST",
              headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
              data: {
                "mobapp_id" : kringle_client_id, "email": customer_email, "customer_id": customer_id,
              	"amount":kringle_redeem_amount, "extra_info":btoa(location.pathname + "/" + (Math.floor(Date.now() / 1000)) +"/checkouts/no-order-" + (Math.floor(Date.now() / 1000)))
              },
              dataType: "json"
            });
          	
            request_obj.done(function(api_redeem_resp) {
              $("#kringle_loyalty_redeem_without_checkout_btn").text('Apply');
              $("#kringle_loyalty_redeem_amt_without_checkout").val(0).focus();
              if(api_redeem_resp.status == 200){
                var redeemed_points = api_redeem_resp.data.redeemed_points;
                var current_updated_point_bal = api_redeem_resp.data.balance_info.redeemed_points;
                
                // get customer's updated loyalty balance and update the widgets
            	get_customer_loyalty_balance(kringle_client_id, customer_email, customer_id, api_redeem_resp.data.amount);                
                // Send redeemed data analytics back to adobe tracker
                var ev = {};
                ev.eventInfo={
                'type':ctConstants.trackEvent, 'eventAction': ctConstants.loyaltyPointsRedeemed,
                'eventLabel' : 'Purchase-' + current_updated_point_bal + '|' + redeemed_points, //how points were redeemed
                'eventValue' : "1" };
                ev.category ={'primaryCategory':ctConstants.other};    
                digitalData.event.push(ev);
                // refresh the discount list...
                get_customer_discounts(kringle_client_id, customer_email, customer_id, true);
                $("#kringle_loyalty_redeem_message").text("Discount redeemed successfully.").show().css('color', 'green');
                
              }else{
              	// Apply Apply Redeem Loyalty Wallet Points Errors Analytics
                var ev = {};
                ev.eventInfo={
                    'type':ctConstants.trackEvent, 'eventAction': ctConstants.inputerror,
                    'eventLabel' : 'LOYALTY - Redeem Error | ' + api_redeem_resp.message, 'eventValue' : "1"
                };
                ev.category ={'primaryCategory':ctConstants.custom};       
                ev.subcategory = 'Error';
                digitalData.event.push(ev);
                if(api_redeem_resp.status == 202){
                  $("#kringle_loyalty_redeem_message").text(api_redeem_resp.message).show().css('color', 'red');
                }else{
                	$("#kringle_loyalty_redeem_message").text(api_redeem_resp.message).show().css('color', 'red');  
                }
              }
            });
            request_obj.fail(function(jqXHR, textStatus, errorThrown) {
              $("#kringle_loyalty_redeem_without_checkout_btn").text('Apply');
              $("#kringle_loyalty_redeem_amt_without_checkout").val(0).focus();
            });
        });
      }
      
    });

  // Get all the customer's associated discounts
  function get_customer_discounts(kringle_client_id, customer_email, customer_id, last_selected=false){
    if($("#kringle-discount-div").length <= 0){
      return false;
    }
    var request_obj = $.ajax({
      url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/offers/shopify/discounts", type: "POST", dataType: "json",
      headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
      data: {"mobapp_id" : kringle_client_id, "email": customer_email, "id": customer_id}
    });

    request_obj.done(function(api_resp) {
      $("#krng-loading-checkout").remove();
      if(api_resp.status == 200){
        var krng_discounts = api_resp.data.discounts;
        if(krng_discounts){
          $('#kringle_discount_select').empty();
          $('#kringle_discount_select').append(new Option("Select Discount", ""));
          
          $("#kringle-discount-div").show();
          $.each(krng_discounts, function (i) {
            var row = krng_discounts[i];
            // create the option
            var custom_discount_title = "💾 " + row.gift_code + "(Amount ₹ " + row.amount + ")";
            $('#kringle_discount_select').append(new Option(custom_discount_title, row.gift_code));
          });
          if(last_selected){
            $("#kringle_discount_select option:last").attr("selected", "selected");    
          }
        }
      }
    });
    request_obj.fail(function(jqXHR, textStatus, errorThrown) {
      $("#krng-loading-checkout").remove();
    });
  }
  
  
  function sendWidgetStats(){
      $('.krng-panel').slideToggle(function(){
        if($('.krng-panel').is(':visible')){
             $('body, html').addClass('add_overflow');
            var ev = {};
            ev.eventInfo={
              'type':ctConstants.trackEvent,
              'eventAction': ctConstants.loyaltyOpens,
              'eventLabel' : 'Loyalty Opens',
              'eventValue' : '1' };
            ev.category ={'primaryCategory':ctConstants.other};    
          	digitalData.page.category.pageType = "kringle widget";
            // Push the data analytics
            digitalData.event.push(ev);
          }else{
             $('body, html').removeClass('add_overflow');
            var ev = {};
            ev.eventInfo={
              'type':ctConstants.trackEvent,
              'eventAction': ctConstants.loyaltyClose,
              'eventLabel' : 'Loyalty Close',
              'eventValue' : '1' };
            ev.category ={'primaryCategory':ctConstants.other};
            digitalData.page.category.pageType = "kringle widget";
            // Push the data analytics
            digitalData.event.push(ev);
          }
      });
    }
  
	$(document).mouseup(function(e) {
	    let krng_container = $(".krng-panel");
	    let krng_button = $('.krng-toggle-button');
	    if (
	        !krng_container.is(e.target) && krng_container.has(e.target).length === 0 &&
	        !krng_button.is(e.target) && krng_button.has(e.target).length === 0
	    ) {
	        krng_container.hide();
	    } else {
	    }
	});
	  // Share Script 
	let shareMessage = ('Lakme Loyalty Program');
    let title = ('Lakme Loyalty Program');
    $('body').on('click','.krng-share-wa',function(){
      
      var ev = {};
      ev.eventInfo={
        'type':ctConstants.trackEvent, 'eventAction': ctConstants.share,
        'eventLabel' : 'Whatsapp Share', 'eventValue' : "1"
      };
      ev.category ={'primaryCategory':ctConstants.referral}; 
      ev.subcategory = 'Lead';
      // Push the data analytics
      digitalData.event.push(ev);
      
      
      var loyalty_referral_code = $("input#loyalty_referral_code_value").val();
      shareMessage = (`Hey Dear, Let’s share the love! Join the Lakmé Glam Squad by using the code ${loyalty_referral_code} when you sign up and earn rewards of 500 Lakmé Glam points!  
	${location.origin}`);
       
        const whatsAppURL = `https://wa.me?text=${encodeURIComponent(shareMessage)}`;

        window.open(whatsAppURL, '_blank');
    })
    $('body').on('click','.krng-share-email',function(){
      
      var ev = {};
      ev.eventInfo={
        'type':ctConstants.trackEvent, 'eventAction': ctConstants.share,
        'eventLabel' : 'Email Share', 'eventValue' : "1"
      };
      ev.category ={'primaryCategory':ctConstants.referral}; 
      ev.subcategory = 'Lead';
      // Push the data analytics
      digitalData.event.push(ev);
      
      
      var loyalty_referral_code = $("input#loyalty_referral_code_value").val();
        shareMessage = (`Hi Dear, Here is your unique code  ${loyalty_referral_code}! Join the Lakme  Glam Squad today to avail  special rewards and offers.  Use the unique code  during Sign up and earn  500 Lakme Glam Points  today! 	
${location.origin}`)
      title = (`You have received a gift from ${customer_full_name ? customer_full_name.value : ''}`);
      const emailURL = `mailto:?subject=${title}&body=${shareMessage}.`;
      window.open(emailURL,'_blank');
//       window.location = emailURL;
    });
    $('body').on('click','.krng-share-fb',function(){
      
      var ev = {};
      ev.eventInfo={
        'type':ctConstants.trackEvent, 'eventAction': ctConstants.share,
        'eventLabel' : 'Facebook Share', 'eventValue' : "1"
      };
      ev.category ={'primaryCategory':ctConstants.referral}; 
      ev.subcategory = 'Lead';
      // Push the data analytics
      digitalData.event.push(ev);
      
      
      
        const fbURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location.href)}`
        window.open(fbURL, '_blank');
    });
    $('body').on('click','.krng-share-copy',function(){
      
      	var ev = {};
        ev.eventInfo={
          'type':ctConstants.trackEvent, 'eventAction': ctConstants.share,
          'eventLabel' : 'Copy Refferal', 'eventValue' : "1"
        };
        ev.category ={'primaryCategory':ctConstants.referral}; 
        ev.subcategory = 'Lead';
        // Push the data analytics
        digitalData.event.push(ev);
      
        var $temp = $("<input>");
        var $url = $("#loyalty_referral_code_value").val();
       let m = 
           (`
Hey Dear, Here is your unique code ${$url} to sign up and Join the Lakmé Glam Squad to get special rewards and offers. Earn 500 Lakmé Glam Points Today!

${location.origin}`)
      
      //$(location).attr('href');
        $("body").append($temp);
        $temp.val(m).select();
        alert(`${$temp.val()} -Copied.`)
        document.execCommand("copy");
        $temp.remove();
    });
    
    $('body').on('click','.krng-share-copy-2' ,function () {
      
      	var ev = {};
        ev.eventInfo={
          'type':ctConstants.trackEvent, 'eventAction': ctConstants.share,
          'eventLabel' : 'Copy Refferal', 'eventValue' : "1"
        };
        ev.category ={'primaryCategory':ctConstants.referral}; 
        ev.subcategory = 'Lead';
        // Push the data analytics
        digitalData.event.push(ev);
      
      
        var $temp = $("<input>");
        var $url = $('#loyalty_referral_code_value').val();
       let m = (`Hey Dear, Here is your unique code ${$url} to sign up and Join the Lakmé Glam Squad to get special rewards and offers. Earn 500 Lakmé Glam Points Today	
${location.origin}`)
        $("body").append($temp);
        $temp.val(m).select();
        alert(`${$temp.val()} -Copied.`);
        document.execCommand("copy");
        $temp.remove();
    });
    
    $('body').on('click','[data-type="navigator"]',function(e){
      e.stopPropagation();
      let data = $(this).data();
	  
      let event_name = data.event;
      
      if(event_name == 'account_logout'){
        
        var ev = {};
        ev.eventInfo={
          'type':ctConstants.trackEvent, 'eventAction': ctConstants.SignOut,
          'eventLabel' : 'Home Page', 'eventValue' : "1"
        };
        ev.category ={'primaryCategory':ctConstants.custom};
        ev.subcategory = 'Interest';

        digitalData.page.pageInfo.destinationURL = location.origin;
        digitalData.page.category.pageType = "Shopify";
        digitalData.page.pageInfo.pageName = "account logout";
        // Push the data analytics
        digitalData.event.push(ev);
        
      }else{
        
		var ev = {};
        ev.eventInfo={
          'type':ctConstants.trackEvent, 'eventAction': ctConstants.linkClick,
          'eventLabel' : event_name, 'eventValue' : "1"
        };
        ev.category ={'primaryCategory':ctConstants.custom};

        digitalData.page.pageInfo.destinationURL = location.origin + data.next;
        digitalData.page.category.pageType = "kringle Loyalty";
        digitalData.page.pageInfo.pageName = data.next;
        // Push the data analytics
        digitalData.event.push(ev);
        
      }

      // check if any link is provided then redirect to next page.
      if(data.next != ""){
        window.open(location.origin + data.next,(data.open ? data.open  : '_self'));
      }
      
    });
  

  	$('body').on('click','#myCheckbox',function(){
      
      if($('#myCheckbox').is(":checked")){
        
//         $('#kringle-growave-social-signup-widget .ssw-social-login-widget').css('pointerEvents','all');
        $('#kringle-growave-social-signup-widget .krng-social-icon svg').css('pointerEvents','all');
        $("#myCheckboxLabel").css("color", "");
        
        
      	var ev = {};
		ev.eventInfo={
		'type':ctConstants.trackEvent,
		'eventAction': ctConstants.Acquisition,
		'eventLabel' : 'Loyalty-Optin',
		'eventValue' : '1' };
		ev.category ={'primaryCategory':ctConstants.conversion};
		ev.subcategory = 'Lead';
        
        digitalData.page.pageInfo.destinationURL = window.location.href;
        digitalData.page.category.pageType = "kringle Loyalty Widget";
        digitalData.page.pageInfo.pageName = "kringle Loyalty Widget";
        
		digitalData.event.push(ev);
      }else{
        $('.login_otp_popup').hide();
//       	$('#kringle-growave-social-signup-widget .ssw-social-login-widget').css('pointerEvents','none');
        $('#kringle-growave-social-signup-widget .krng-social-icon svg').css('pointerEvents','none');
        $("#myCheckboxLabel").css("color", "red");
      }
      
    });
  
  $('body').on('click','#kringle-growave-social-signup-widget',function(){
		if($('#myCheckbox').is(":checked")){
          $("#myCheckboxLabel").css("color", "");
        }else{
          $("#myCheckboxLabel").css("color", "red");
          $('#myCheckbox').foucs();
        }

  });
  
  $('body').on('click','#moksha-signup-popup',function(){
		if($('#myCheckbox').is(":checked")){
          $("#myCheckboxLabel").css("color", "");
          $('.login_otp_popup').show();
        }else{
          $("#myCheckboxLabel").css("color", "red");
          $('#myCheckbox').foucs();
          $('.login_otp_popup').hide();
        }
  });

  function copyToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          alert('Copying Discount Code : ' + text);
      } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
      return;
  }
  $('body').on('change','#kringle_discount_select',function(){
      let text = $(this).val();
      if(!text) return;
      copyToClipboard(text);
  });
    
})(jQuery);